import React from "react";
import { useTranslation } from "react-i18next";

import * as S from "./text.input.styles";

export const Input = ({
  label,
  placeholder,
  type,
  name,
  validation,
  error,
  register,
  font,
  background,
  top,
  height,
  width,
  depends,
  labelcolor,
  classname,
}) => {
  const { t } = useTranslation();

  return (
    <div>
      <S.FormGroup className="form-group">
        {label ? (
          <S.FormLabel labelcolor={labelcolor} fontsize={font}>
            {t(`${label}`)}
          </S.FormLabel>
        ) : (
          ""
        )}
        <S.Fields
          backcolor={background}
          fontsize={font}
          height={height}
          width={width}
          error={error}
          className={classname === "" ? classname : "form-control"}
          type={type}
          ref={
            depends
              ? register(name, {
                  validate: (value) =>
                    value === depends.field || depends.validation.error,
                })
              : ""
          }
          placeholder={placeholder ? t(`${placeholder}`) : t(`${label}`)}
          {...register(name, { ...validation })}
        />
        <S.Error top={top}>{error}</S.Error>
      </S.FormGroup>
    </div>
  );
};
